import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import { LIBList, LIBListItem, LIBHeadline, LIBLink } from "../../components/LinkInBio";

const LinkInBioPage = () => {
	return (
	  <Layout>
	    <Seo title="Link in Bio" />
		<p>&nbsp;</p>
		<div className="main--centerwrapper">
			<StaticImage
			src="../../images/photos/pressRes/_MG_1300.jpg"
			alt="Jesse Rivest press image"
			placeholder="blurred"
			layout="constrained"
			className="main--centered"
			imgClassName="img--bordered-large"
			width={500}
			/>
		</div>
		<div className="main--centerwrapper main--centerwrapper__column">
			<h4 className="main--centered">@jesserivest</h4>
			<p className="main--centered centeredText snugTop">
				Singer-songwriter and guitarist split-based between the<br />
				capital of Brazil and hometown Kelowna, British Columbia.<br />
				Baking, bicycles, nature, Sunday adventures.
			</p>
		</div>
		<LIBList>

			<LIBListItem>
				<LIBHeadline>
					Twenty years! 💿 <span className="italic">Seventeen Oh-Two Oh-Six</span>
				</LIBHeadline>
				<LIBLink>
					<Link to='/news/202605/#1'>
						Read & videos
					</Link>
				</LIBLink>
			</LIBListItem>

			<LIBListItem>
				<LIBHeadline>
					Jessellaneous collab: <span className="italic">'Oumuamua</span>
				</LIBHeadline>
				<LIBLink>
					<a href='//open.spotify.com/album/2xGrqjBEWDfHmDQDVe9qqS?si=IZgS2mp_SUuhXpsdoJm62w'>
						Listen Spotify
					</a>
				</LIBLink>
			</LIBListItem>

			<LIBListItem>
				<LIBHeadline>
					Hire me to help with your tunes
				</LIBHeadline>
				<LIBLink>
					<Link to='/hire/'>
						I'm on AirGigs
					</Link>
				</LIBLink>
			</LIBListItem>

			<LIBListItem>
				<LIBHeadline>
					Got Time for a Song?
				</LIBHeadline>
				<LIBLink>
					<a href="//youtube.com/playlist?list=PLUnT5wM9jMYPH7Pe7ggeKw-mtb0ZMUaJ-&si=HQeujrJV-uRNm71u">
						video song series
					</a>
				</LIBLink>
			</LIBListItem>

			<LIBListItem>
				<LIBHeadline>
					CDs and tee shirts available
				</LIBHeadline>
				<LIBLink>
					<Link to="/merch/">
						See merch
					</Link>
				</LIBLink>
			</LIBListItem>

			<LIBListItem>
				<LIBHeadline>
					Get to know me
				</LIBHeadline>
				<LIBLink>
					<Link to="/music/">
						Playlist: select tunes
					</Link>
					&nbsp;or&nbsp;
					<a href='//www.youtube.com/playlist?list=PLUnT5wM9jMYNnG6Hs5geY3Qi7O2hDQwt4'>
						Playlist at Youtube
					</a>
				</LIBLink>
			</LIBListItem>

			<LIBListItem>
				<LIBHeadline>
					Get on board
				</LIBHeadline>
				<LIBLink>
					<a href="//bit.ly/email-list-JR">
						Mailing list: join me
					</a>
					&nbsp;or&nbsp;
					<a href="//patreon.com/jesserivest/">
						Patreon: payment optional
					</a>
				</LIBLink>
			</LIBListItem>

		</LIBList>
	  </Layout>
  );
}
export default LinkInBioPage
